import { z } from 'zod';
export const JsonValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema),
    z.record(z.string(), JsonValueSchema),
]));
export const ProxyRouteMethodSchema = z.enum(['POST', 'GET']);
export const ProxyRouteQuerySchema = z.record(z.string(), z.string()).optional();
function createRouteLabelSchema(routes) {
    const routeLabels = Object.keys(routes);
    return z.custom((value) => typeof value === 'string' && routeLabels.includes(value));
}
export function defineProxyApi(input) {
    const routeLabelSchema = createRouteLabelSchema(input.routes);
    const proxyRequestSchema = z.object({
        route: routeLabelSchema,
        payload: JsonValueSchema,
        query: ProxyRouteQuerySchema,
    });
    const getRouteDefinition = (routeLabel) => {
        const route = input.routes[routeLabel];
        return {
            label: routeLabel,
            method: route.method,
            path: route.path,
            timeoutMs: route.timeoutMs,
            requestSchema: route.requestSchema,
            responseSchema: route.responseSchema,
        };
    };
    return {
        clientKey: input.clientKey,
        routes: input.routes,
        configSchema: input.configSchema,
        routeLabelSchema,
        proxyRequestSchema,
        getRouteDefinition,
        getHttpClientConfig: (config) => {
            const parsedConfig = input.configSchema.parse(config);
            return input.buildHttpClientConfig(parsedConfig);
        },
    };
}
export function buildProxyConfigShape(apis) {
    const combinedShape = {};
    for (const api of apis) {
        for (const [key, value] of Object.entries(api.configSchema.shape)) {
            if (key in combinedShape) {
                throw new Error(`Duplicate proxy config key found: ${key}`);
            }
            combinedShape[key] = value;
        }
    }
    return combinedShape;
}
